import React, { useState } from 'react';

const DiscoveryForm = ({ selectedProject, onProjectChange, selectedModel, userInfo }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [titlePrompt, setTitlePrompt] = useState('');

  const handleGenerate = () => {
    console.log('Generating discovery document with title:', titlePrompt);
    // Here you would typically call an API to generate the document
    setIsModalOpen(false);
    setTitlePrompt('');
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>🔍 Discovery</h1>
        <p style={styles.comingSoon}>Coming Soon</p>
        <p style={styles.subtitle}>NPD Initiatives & Project Discovery Portal</p>
      </div>
      
      <div style={styles.welcomeSection}>
        <div style={styles.welcomeCard}>
          <h2 style={styles.welcomeTitle}>
            Welcome to Discovery{userInfo?.name && `, ${userInfo.name}`}
          </h2>
          {userInfo?.email && (
            <p style={styles.userEmail}>{userInfo.email}</p>
          )}
          <p style={styles.welcomeText}>
            This is your central hub for exploring NPD Initiatives and project discovery activities.
            Use this space to research, analyze, and document new product development opportunities.
          </p>
          
          <div style={styles.quickActions}>
            <h3 style={styles.actionsTitle}>Quick Actions</h3>
            <div style={styles.actionGrid}>
              <div style={{...styles.actionCard, ...styles.actionCardDisabled}}>
                <div style={styles.actionIcon}>📝</div>
                <h4 style={styles.actionCardTitle}>What, Why, How</h4>
                <p style={styles.actionCardText}>Start a new discovery document</p>
              </div>
              
              <div style={styles.actionCard}>
                <div style={styles.actionIcon}>🎯</div>
                <h4 style={styles.actionCardTitle}>Track Progress</h4>
                <p style={styles.actionCardText}>Monitor initiative status and milestones</p>
              </div>
              
              <div style={styles.actionCard}>
                <div style={styles.actionIcon}>🔬</div>
                <h4 style={styles.actionCardTitle}>Research & Analysis</h4>
                <p style={styles.actionCardText}>Conduct discovery research and analysis</p>
              </div>
              
              <div style={styles.actionCard}>
                <div style={styles.actionIcon}>📊</div>
                <h4 style={styles.actionCardTitle}>Generate Reports</h4>
                <p style={styles.actionCardText}>Create discovery and progress reports</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2 style={styles.modalTitle}>What, Why, How</h2>
            <p style={styles.modalSubtitle}>Enter a title to generate a new discovery document.</p>
            <input
              type="text"
              value={titlePrompt}
              onChange={(e) => setTitlePrompt(e.target.value)}
              placeholder="e.g., 'AI-Powered Customer Support Bot'"
              style={styles.modalInput}
            />
            <div style={styles.modalActions}>
              <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseButton}>
                Cancel
              </button>
              <button onClick={handleGenerate} style={styles.modalGenerateButton}>
                Generate
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div style={styles.infoSection}>
        <div style={styles.infoCard}>
          <h3 style={styles.infoTitle}>Getting Started</h3>
          <ul style={styles.infoList}>
            <li>Select a project or initiative to explore</li>
            <li>Use the search and filtering tools to find specific items</li>
            <li>Click on items to view detailed information</li>
            <li>Generate reports for stakeholder updates</li>
          </ul>
        </div>
        
        <div style={styles.infoCard}>
          <h3 style={styles.infoTitle}>Recent Activity</h3>
          <p style={styles.infoText}>
            Track your recent discovery activities and continue where you left off.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '80vh',
  },
  header: {
    textAlign: 'center',
    marginBottom: '3rem',
    paddingBottom: '2rem',
    borderBottom: '2px solid #e9ecef',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '700',
    color: '#2c3e50',
    margin: '0 0 0.5rem 0',
    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  comingSoon: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#dc3545',
    margin: '0 0 1rem 0',
    textTransform: 'uppercase',
    letterSpacing: '2px',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#6c757d',
    margin: 0,
    fontWeight: '300',
  },
  welcomeSection: {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
    border: '1px solid #e9ecef',
  },
  welcomeTitle: {
    fontSize: '2rem',
    color: '#34495e',
    marginBottom: '0.5rem',
  },
  userEmail: {
    fontSize: '0.9rem',
    color: '#6c757d',
    fontStyle: 'italic',
    marginBottom: '1rem',
    opacity: '0.8',
  },
  welcomeText: {
    fontSize: '1rem',
    color: '#6c757d',
    lineHeight: '1.6',
    marginBottom: '2.5rem',
  },
  quickActions: {
    textAlign: 'center',
  },
  actionsTitle: {
    fontSize: '1.5rem',
    color: '#34495e',
    marginBottom: '1.5rem',
  },
  actionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1.5rem',
  },
  actionCard: {
    backgroundColor: '#f8f9fa',
    padding: '1.5rem',
    borderRadius: '10px',
    textAlign: 'center',
    border: '1px solid #e9ecef',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
  },
  actionCardDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
    backgroundColor: '#e9ecef',
  },
  actionCardHover: {
    transform: 'translateY(-5px)',
    boxShadow: '0 12px 20px rgba(0,0,0,0.1)',
  },
  actionIcon: {
    fontSize: '2.5rem',
    marginBottom: '1rem',
  },
  actionCardTitle: {
    fontSize: '1.2rem',
    fontWeight: '600',
    color: '#34495e',
    marginBottom: '0.5rem',
  },
  actionCardText: {
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  infoSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '2rem',
    marginTop: '3rem',
  },
  infoCard: {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.06)',
  },
  infoTitle: {
    fontSize: '1.4rem',
    color: '#34495e',
    marginBottom: '1rem',
  },
  infoList: {
    listStyle: 'none',
    padding: 0,
  },
  infoListLi: {
    marginBottom: '0.75rem',
    color: '#6c757d',
    position: 'relative',
    paddingLeft: '20px',
  },
  infoListLiBefore: {
    content: '"✓"',
    position: 'absolute',
    left: 0,
    color: '#28a745',
    fontWeight: 'bold',
  },
  infoText: {
    color: '#6c757d',
    lineHeight: '1.6',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '2.5rem',
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    width: '90%',
    maxWidth: '500px',
    textAlign: 'center',
  },
  modalTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '0.5rem',
  },
  modalSubtitle: {
    fontSize: '1rem',
    color: '#666',
    marginBottom: '2rem',
  },
  modalInput: {
    width: '100%',
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: '2rem',
    boxSizing: 'border-box',
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1rem',
  },
  modalCloseButton: {
    padding: '0.6rem 1.2rem',
    border: '1px solid #ccc',
    backgroundColor: 'transparent',
    color: '#555',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  modalGenerateButton: {
    padding: '0.6rem 1.2rem',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
};

export default DiscoveryForm;
